<template>
  <SearchResultsGrid :search-input="searchInput" :search-query="searchQuery" />
</template>

<script setup lang="ts">
import type {
  SearchResultsInput,
  SearchSuggestionType,
} from "~/graphql/generated";

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/zoekresultaten/[searchQuery]/[type]/[referenceId]",
    fr: "/resultatdecherche/[searchQuery]/[type]/[referenceId]",
    nl: "/zoekresultaten/[searchQuery]/[type]/[referenceId]",
  },
});

// Get search params from the route
const route = useRoute();
const searchQuery = computed(() => route.params.searchQuery as string);

const referenceId = computed(
  () => route.params.referenceId as string | undefined
);
const type = computed(
  () =>
    friendlyToEnum(route.params.type as string) as
      | SearchSuggestionType
      | undefined
);
// What the user typed in the search before selecting the suggestion, we need to send this to the server for stats
const userSearchQuery = computed(() => route.query.q as string);

// Create the search input
const searchInput = computed<SearchResultsInput>(() => {
  // If we have a reference, use that
  if (referenceId.value && type.value) {
    return {
      searchSuggestion: {
        referenceId: referenceId.value,
        type: type.value,
      },
      query: userSearchQuery.value,
    };
  }

  // Otherwise, use the search query
  return {
    query: searchQuery.value,
  };
});
</script>

<style lang="scss" scoped>
.searchbar {
  z-index: 1;
}
</style>
